module.exports = __webpack_public_path__ + "f4693779262dfbc18b21d1d26f95ebd8.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/share-princess-2.png
// module id = 496
// module chunks = 0